var React = require('react');

function ArrowRightGray (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#434343;}")),React.createElement("g",{"transform":"translate(-1254 -507)","key":1},React.createElement("path",{"className":"a","d":"M9,0,7.364,1.636l6.195,6.195H0v2.338H13.558L7.364,16.364,9,18l9-9Z","transform":"translate(1254 507)"}))]);
}

ArrowRightGray.displayName = "ArrowRightGray";

ArrowRightGray.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = ArrowRightGray;

ArrowRightGray.default = ArrowRightGray;
